var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("SearchForm", {
        attrs: { banner: _vm.banner, recaptcha_key: _vm.recaptcha_key },
        on: { search: _vm.search }
      }),
      _vm._v(" "),
      _vm.loading
        ? _c("section", { staticClass: "wrap-billet-content" }, [_vm._m(0)])
        : _vm.error
        ? _c("section", { staticClass: "wrap-billet-content" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "small-12 medium-12 large-10 medium-centered columns"
                },
                [_c("p", [_vm._v(_vm._s(_vm.error))])]
              )
            ])
          ])
        : _vm.boletos.length == 0 && _vm.cpf_cnpj != ""
        ? _c("section", { staticClass: "wrap-billet-content" }, [_vm._m(1)])
        : _vm.boletos.length != 0
        ? _c("SearchResult", {
            attrs: {
              popup_simulacao: _vm.popup_simulacao,
              banner_popup: _vm.banner_popup,
              boletos: _vm.boletos
            },
            on: { atualizarVencimento: _vm.atualizarVencimento }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticStyle: { display: "none" } }, [
        _c("div", { attrs: { id: "popup_parcele_clic" } }, [
          _c("a", { attrs: { href: _vm.url_clic, target: "_blank" } }, [
            _c("img", { attrs: { src: _vm.banner_popup } })
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "small-12 medium-12 large-10 medium-centered columns" },
        [_c("p", [_vm._v("Carregando...")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "small-12 medium-12 large-10 medium-centered columns" },
        [_c("p", [_vm._v("Nenhum boleto encontrado.")])]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }